<template lang="pug">
  div.container.mx-auto
    slot
</template>

<script>
export default {
  name: 'Container'
}
</script>
